export const incomeSelector = (state) => state.incomeStaffReducer.all;
export const branchSelector = (state) => state.incomeStaffReducer.branch;
export const userInfoSelector = (state) => state.incomeStaffReducer.userInfo;
export const incomeByBranchSelector = (state) => state.incomeStaffReducer.incomeByBranch;

